export const DisplayOptions = {
    Shown: 1,
    Hidden: 2
};

export const GenerateAdUsersTexts = {
    GenerateAdUsersTitle: "Congratulations!",
    GenerateAdUsersParagraph: "You have now created an AD user"
}